import * as React from "react";
import { CloudState } from "../types";

export const CloudStateContext = React.createContext<
  React.MutableRefObject<CloudState[]>
>(null!);
